// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"dddb642d","552":"e4addc12"}[chunkId] + ".chunk.js";
};